
function accordion(e) {
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var faqBody = this.nextElementSibling;
      if (faqBody.style.maxHeight) {
        faqBody.style.maxHeight = null;
      } else {
        faqBody.style.maxHeight = faqBody.scrollHeight + "px";
      }
    });
  }
}

function tab() {
  const tabList = document.querySelectorAll('[data-toggle="tab"]');
  tabList.forEach(function (list) {
    list.addEventListener("click", function () {
      const targetId = this.getAttribute("data-target"),
        target = document.querySelector(targetId);
      this.parentElement
        .querySelectorAll('[data-toggle="tab"]')
        .forEach(function (list) {
          list.classList.remove("active");
        });
      this.classList.add("active");
      target.classList.add("active");
      getSiblings(target).forEach(function (pane) {
        pane.classList.remove("active");
      });
    });
  });
};

function HeaderSticky(){
  const headerStickyWrapper = document.querySelector('header');
  const headerStickyTarget = document.querySelector('.header-sticky');

  if(headerStickyTarget){
    let headerHeight = headerStickyWrapper.clientHeight;
    window.addEventListener('scroll', function(){

      if(window.scrollY > 200 ){
        headerStickyTarget.classList.add('sticky');
      }else{
        headerStickyTarget.classList.remove('sticky');
      }
    })
  }
}

function header_mobile() {
  /* Mobile Menu Function */
  const offcanvasHeader = function () {
    const offcanvasOpen = document.querySelector(
        ".header-btn-menu"
      ),
      offcanvasClose = document.querySelector(".menumobile-close"),
      offcanvasHeader = document.querySelector(".menumobile-header"),
      offcanvasMenu = document.querySelector(".menumobile-menu"),
      body = document.querySelector("body");

    /* Add a Button For SubMenu Toggle */
    offcanvasMenu
      .querySelectorAll(".menumobile-sub-menu")
      .forEach(function (ul) {
        const subMenuToggle = document.createElement("button");
        subMenuToggle.classList.add("menumobile-sub-menu_toggle");
        subMenuToggle.setAttribute("aria-label", "menu collapse");
        ul.parentNode.appendChild(subMenuToggle);
      });

    /* Open/Close Menu On Click Toggle Button */
    offcanvasOpen.addEventListener("click", function (e) {
      e.preventDefault();
      offcanvasHeader.classList.add("open");
      body.style.overflowY = "hidden";
    });
    offcanvasClose.addEventListener("click", function (e) {
      e.preventDefault();
      offcanvasHeader.classList.remove("open");
      body.style.overflowY = null;
    });
    /* Open/Close Sub Menu On Click Toggle Button */
    offcanvasMenu
      .querySelectorAll(".menumobile-sub-menu_toggle")
      .forEach(function (toggle) {
        toggle.addEventListener("click", function (e) {
          e.preventDefault();
          const parent = this.parentElement;
          if (parent.classList.contains("active")) {
            this.classList.remove("active");
            parent.classList.remove("active");
            parent
              .querySelectorAll(".menumobile-sub-menu")
              .forEach(function (subMenu) {
                subMenu.parentElement.classList.remove("active");
                subMenu.nextElementSibling.classList.remove("active");
                slideUp(subMenu);
              });
          } else {
            this.classList.add("active");
            parent.classList.add("active");
            slideDown(this.previousElementSibling);
            getSiblings(parent).forEach(function (item) {
              item.classList.remove("active");
              item
                .querySelectorAll(".menumobile-sub-menu")
                .forEach(function (subMenu) {
                  subMenu.parentElement.classList.remove("active");
                  subMenu.nextElementSibling.classList.remove("active");
                  slideUp(subMenu);
                });
            });
          }
        });
      });

    document.addEventListener("click", function (event) {
      if (
        !event.target.closest(".header-btn-menu") &&
        !event.target.classList.contains(
          ".header-btn-menu".replace(/\./, "")
        )
      ) {
        if (
          !event.target.closest(".menumobile-header") &&
          !event.target.classList.contains(
            ".menumobile-header".replace(/\./, "")
          )
        ) {
          offcanvasHeader.classList.remove("open");
          body.style.overflowY = null;
        }
      }
    });

    /* Remove Mobile Menu Open Class & Hide Mobile Menu When Window Width in More Than 991 */
    window.addEventListener("resize", function () {
      if (window.outerWidth >= 992) {
        offcanvasHeader.classList.remove("open");
        body.style.overflowY = null;
      }
    });
  };
  /* Mobile Menu Active */
  offcanvasHeader();
}

function search() {
  // Header Search offcanvas
  let offcanvasSearchTrigger = document.querySelector(
      ".header__actions_btn--search"
    ),
    offcanvasSidebarSearch = document.getElementById(
      "predictive__search_overlay"
    ),
    offcanvasSearchClose = document.getElementById("search__close_btn");

  if (offcanvasSearchTrigger) {
    offcanvasSearchTrigger.addEventListener("click", (event) => {
      event.preventDefault();
      offcanvasSidebarSearch.classList.add("active");
      document.querySelector("body").classList.add("added__overlay_search");

      offcanvasSidebarSearch.addEventListener(
        "transitionend",
        () => {
          offcanvasSidebarSearch.focus();
          trapFocus(offcanvasSidebarSearch);
        },
        { once: true }
      );
    });

    offcanvasSidebarSearch.addEventListener("keyup", (evt) => {
      if (evt.code === "Escape") {
        offcanvasSidebarSearch.classList.remove("active");
        document
          .querySelector("body")
          .classList.remove("added__overlay_search");
        removeTrapFocus(offcanvasSearchTrigger);
      }
    });
  }

  if (offcanvasSearchClose) {
    offcanvasSearchClose.addEventListener("click", (event) => {
      event.preventDefault();
      offcanvasSidebarSearch.classList.remove("active");
      document
        .querySelector("body")
        .classList.remove("added__overlay_search");
      removeTrapFocus(offcanvasSearchTrigger);
    });
  }

  document.addEventListener("click", function (event) {
    let eventTarget = event.target;
    if (
      !eventTarget.closest("#predictive__search_overlay") &&
      !eventTarget.closest(".header__actions_btn--search")
    ) {
      offcanvasSidebarSearch.classList.remove("active");
      document
        .querySelector("body")
        .classList.remove("added__overlay_search");
    }
  });
}

function cartActions(){
    
  let cartActionsButtons = document.querySelectorAll('.cart-notification-action-button'),
   cartCancelButtons = document.querySelectorAll('.action-drawer-footer .button-cancel'),
   cartSaveButtons = document.querySelectorAll('.action-drawer-footer .button-save'),
   cartNoteData = document.getElementById('cartNote'),
   actionOverlay = document.querySelector('.cart-overlay'),
   cartNote = document.getElementById('cart_note_drawer'),
   ShippingCalc = document.getElementById('shipping-drawer'),
   couponDrawer = document.getElementById('coupon_drawer'),
   shippingCountry = document.getElementById('AddressCountry_Shipping'),
   countryState = document.getElementById('AddressProvince_shipping'),
   shippingCountryZip = document.getElementById('ShippingAddressZip');
  
  fetch('/cart.js')
   .then(response => response.json()) 
   .then(json => {
//  cartNoteData.value = json.note;
 // console.log(json);
   })
   
   .catch(err => console.log(err));

  cartActionsButtons.forEach((item)=> {
    item.addEventListener('click', () => {
    if(item.dataset.drawer === "note"){
       cartNote.classList.add('active');
      actionOverlay.classList.add('active');
    }else if(item.dataset.drawer === "shipping"){
        ShippingCalc.classList.add('active');
       actionOverlay.classList.add('active');
    }else{
      couponDrawer.classList.add('active');
      actionOverlay.classList.add('active');
    }
    });
  });
  cartCancelButtons.forEach((item) =>{
   item.addEventListener('click', () => {
      if(item.dataset.action === "note"){
        cartNote.classList.remove('active');
         actionOverlay.classList.remove('active');
       }else if(item.dataset.action === "shipping"){
          ShippingCalc.classList.remove('active');
         actionOverlay.classList.remove('active');
      }else{
        couponDrawer.classList.remove('active');
        actionOverlay.classList.remove('active');
      }
    });               
  });

 cartSaveButtons.forEach((item) => {
  item.addEventListener('click', () => {
   if(item.dataset.action === "note"){                      
     let noteUpdate = cartNoteData.value;
     item.classList.add('loading');  
     let body = JSON.stringify({
       note: noteUpdate
    });
    fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
         return response.json();
      })
      .then((state) => {
         cartNote.classList.remove('active');
         actionOverlay.classList.remove('active');
        item.classList.remove('loading');  
      })
      .catch((e) => {
          console.error(e);
       });
 }
     if(item.dataset.action === "shipping"){
      let shippingRatePackage = document.querySelector('.shipping-rate-package');
      let shippingAddressWrapper = document.querySelector('.shipping-rate-message');
      let shippingAddressCount = document.querySelector('.shipping-address-count');
       
      shippingRatePackage.innerHTML = '';
       if(shippingCountry.value !== "---"){
         item.classList.add('loading');  
         fetch(`/cart/shipping_rates.json?shipping_address%5Bzip%5D=${shippingCountryZip.value}&shipping_address%5Bcountry%5D=${shippingCountry.value}&shipping_address%5Bprovince%5D=${countryState.value}`)
         .then((response) => {
           if (response.ok) {
             return response.json()
           } else {
             throw `${window.shipping.wrong_message}`;
           }
         })
         .then((response) => {
           item.classList.remove('loading'); 
           
           shippingAddressWrapper.classList.remove('no-js-inline');
           shippingAddressCount.innerText = `${response.shipping_rates.length}`
           response.shipping_rates.map((item) => {
             let text = document.createElement("P"); 
             text.setAttribute("class", 'mb-0');
             text.innerText = `${item.name}: ${shopCurrencySymbol}${item.price}`
             shippingRatePackage.appendChild(text);
           })
         })
         .catch((e) => {
           item.classList.remove('loading');     
           shippingAddressWrapper.classList.add('no-js-inline');
           shippingRatePackage.innerHTML = `<p class="error mt-15">${e}</p>`;
         });
       }else{
         shippingAddressWrapper.classList.add('no-js-inline');
         shippingRatePackage.innerHTML = `<p class="error mt-15">${window.shipping.country_label}</p>`;
       }
   } 
     if(item.dataset.action === "coupon"){
         let wrongMessage = document.querySelector('.coupon_wrong_message');
    let couponCode = document.getElementById('coupon_code').value;
         localStorage.setItem('coupon', couponCode);
       if(couponCode){
         couponDrawer.classList.remove('active');
         actionOverlay.classList.remove('active');
         wrongMessage.classList.add('no-js-inline');
       }else{
         wrongMessage.classList.remove('no-js-inline');
       }
     }
   }); 
 });


  let countrySelectsShipping = document.querySelectorAll('data-address-country-select');
  if(shippingCountry && countryState){
    if (Shopify && Shopify.CountryProvinceSelector) {
        new Shopify.CountryProvinceSelector('AddressCountry_Shipping', 'AddressProvince_shipping', {
          hideElement: 'AddressProvinceContainerNewShiping'
        });
      }
  }


}

function categoryMenu(e) {
    
  activeClassAction(".categories-menu-header", ".dropdown-categories-menu");
  
  const CategorySubMenu = document.querySelector(".category-mobile-menu");
  if (CategorySubMenu) {
    CategorySubMenu.querySelectorAll(".category-sub-menu").forEach(function (
                                                                     ul
    ) {
      let catsubMenuToggle = document.createElement("button");
      catsubMenuToggle.classList.add("category-sub-menu_toggle");
      ul.parentNode.appendChild(catsubMenuToggle);
    });
  }
  let categoryMenuWrapper = document.querySelector(
    ".category-mobile-menu_ul"
  );
  if (categoryMenuWrapper) {
    categoryMenuWrapper.addEventListener("click", function (e) {
      let targetElement = e.target;
      if (targetElement.classList.contains("category-sub-menu_toggle")) {
        const parent = targetElement.parentElement;
        if (parent.classList.contains("active")) {
          targetElement.classList.remove("active");
          parent.classList.remove("active");
          parent
          .querySelectorAll(".category-sub-menu")
          .forEach(function (subMenu) {
            subMenu.parentElement.classList.remove("active");
            subMenu.nextElementSibling.classList.remove("active");
            slideUp(subMenu);
          });
        } else {
          targetElement.classList.add("active");
          parent.classList.add("active");
          slideDown(targetElement.previousElementSibling);
          getSiblings(parent).forEach(function (item) {
            item.classList.remove("active");
            item
            .querySelectorAll(".category-sub-menu")
            .forEach(function (subMenu) {
              subMenu.parentElement.classList.remove("active");
              subMenu.nextElementSibling.classList.remove("active");
              slideUp(subMenu);
            });
          });
        }
      }
    });
  }
  
  
}

function footer_faq(){
  let accordion = true
  const footerWidgetAccordion = function () {
    accordion = false
    document.querySelectorAll(".footer-widget-toggle").forEach(function (item) {
      item.addEventListener('click', function () {
        const footerWidget = this.closest('.footer-widget'),
              footerWidgetInner = footerWidget.querySelector('.footer-widget-inner')
        if(footerWidget.classList.contains('active')) {
          footerWidget.classList.remove('active')
          slideUp(footerWidgetInner)
        } else {
          footerWidget.classList.add('active')
          slideDown(footerWidgetInner)
          getSiblings(footerWidget.parentElement).forEach(function (item) {
            const footerWidget = item.querySelector('.footer-widget'),
                  footerWidgetInner = item.querySelector('.footer-widget-inner')
            footerWidget.classList.remove('active')
            slideUp(footerWidgetInner)
          })

        }
      })
    })
  }
  if(accordion){
    footerWidgetAccordion();
  }
  window.addEventListener('resize', function () {
    document.querySelectorAll('.footer-widget').forEach(function (item) {
      if(window.outerWidth >= 768) {
        item.classList.remove('active')
        item.querySelector('.footer-widget-inner').style.display = ''
      }
    })
    if(accordion) {footerWidgetAccordion()}
  })
}

function toggle_view_product(e) {
   
  // product Column
  const productColBtnWrapper = document.querySelector(
    ".product-show-col-buttons"
  );
  if(productColBtnWrapper){
      const gridColumnButtons = productColBtnWrapper.querySelectorAll(".gird-column-icon");
      const girColumnWrapper = document.querySelector("#ProductGridContainer");
      const girColumnWrapperClssList = girColumnWrapper.classList;

      let gridClassName = localStorage.getItem("gridColumn");
      if (gridClassName) {
        girColumnWrapper.classList.remove(
          "grid-col-2",
          "grid-col-3",
          "grid-col-4",
          "list"
        );
        girColumnWrapper.classList.add(gridClassName);
      }

      gridColumnButtons.forEach((singleItem) => {
        if (gridClassName) {
          switch (gridClassName) {
            case "grid-col-2":
              if (singleItem.classList.contains("product-col-two")) {
                singleItem.classList.add("active");
                getSiblings(singleItem).forEach(function (item) {
                  item.classList.remove("active");
                });
              }
              break;
            case "grid-col-3":
              if (singleItem.classList.contains("product-col-three")) {
                singleItem.classList.add("active");
                getSiblings(singleItem).forEach(function (item) {
                  item.classList.remove("active");
                });
              }
              break;
            case "list":
              if (singleItem.classList.contains("product-list")) {
                singleItem.classList.add("active");
                getSiblings(singleItem).forEach(function (item) {
                  item.classList.remove("active");
                });
              }
              break;
            default:
              if (singleItem.classList.contains("product-col-four")) {
                singleItem.classList.add("active");
                getSiblings(singleItem).forEach(function (item) {
                  item.classList.remove("active");
                });
              }
          }
        }

        singleItem.addEventListener("click", (event) => {
          singleItem.classList.add("active");
          getSiblings(singleItem).forEach(function (item) {
            item.classList.remove("active");
          });

          if (singleItem.classList.contains("product-col-two")) {
            localStorage.setItem("gridColumn", "grid-col-2");

            gridClassName = localStorage.getItem("gridColumn");
            girColumnWrapper.classList.add(gridClassName);

            if (
              girColumnWrapperClssList.contains("list") ||
              girColumnWrapperClssList.contains("grid-col-4") ||
              girColumnWrapperClssList.contains("grid-col-3") ||
              girColumnWrapperClssList.contains("grid-col-1")
            ) {
              girColumnWrapper.classList.remove(
                "list",
                "grid-col-4",
                "grid-col-3",
                "grid-col-1"
              );
            }
          } else if (singleItem.classList.contains("product-list")) {
            localStorage.setItem("gridColumn", "list");
            gridClassName = localStorage.getItem("gridColumn");

            girColumnWrapper.classList.add(gridClassName);
            if (
              girColumnWrapperClssList.contains("grid-col-4") ||
              girColumnWrapperClssList.contains("grid-col-3") ||
              girColumnWrapperClssList.contains("grid-col-2") ||
              girColumnWrapperClssList.contains("grid-col-1")
            ) {
              girColumnWrapper.classList.remove(
                "grid-col-4",
                "grid-col-3",
                "grid-col-2",
                "grid-col-1"
              );
            }
          } else if (singleItem.classList.contains("product-col-three")) {
            localStorage.setItem("gridColumn", "grid-col-3");
            gridClassName = localStorage.getItem("gridColumn");

            girColumnWrapper.classList.add(gridClassName);
            if (
              girColumnWrapperClssList.contains("list") ||
              girColumnWrapperClssList.contains("grid-col-4") ||
              girColumnWrapperClssList.contains("grid-col-2") ||
              girColumnWrapperClssList.contains("grid-col-1")
            ) {
              girColumnWrapper.classList.remove(
                "list",
                "grid-col-4",
                "grid-col-2",
                "grid-col-1"
              );
            }
          } else if (singleItem.classList.contains("product-col-four")) {
            localStorage.setItem("gridColumn", "grid-col-4");
            gridClassName = localStorage.getItem("gridColumn");
            girColumnWrapper.classList.add(gridClassName);
            if (
              girColumnWrapperClssList.contains("list") ||
              girColumnWrapperClssList.contains("grid-col-3") ||
              girColumnWrapperClssList.contains("grid-col-2") ||
              girColumnWrapperClssList.contains("grid-col-1")
            ) {
              girColumnWrapper.classList.remove(
                "list",
                "grid-col-3",
                "grid-col-2",
                "grid-col-1"
              );
            }
          }
        });
      });
  }

}


window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.productSlider = (function () {
  function sliderProduct(e) {
    const initialTheme = localStorage.getItem('theme') || 'light';
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 2,
      sliderRows = parseInt(e.dataset.sliderRows),
      sliderSpace = parseInt(e.dataset.slideshow),
      sliderGrid = "column",
      sliderLoop = e.dataset.loop;

    if (sliderLoop === "true") {
      sliderLoop = true;
    } else {
      sliderLoop = false;
    }

    if (sliderRows > 1) {
      sliderGrid = "row";
      sliderLoop = false;
    }
    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      largeDesktopShow = parseInt(e.dataset.showLarge);
      tabletShow = parseInt(e.dataset.showTablet);
      mobileShow = parseInt(e.dataset.showMobile);
    }

    var swiper = new Swiper(sliderContainer, {
      loop: sliderLoop,
      slidesPerView: mobileShow,
      spaceBetween: sliderSpace,
      observer: true,
      observeParents: true,
      grid: {
        rows: sliderRows,
        fill: sliderGrid,
      },
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: e.querySelector(".product-slider-wrapper .swiper-button-next"),
        prevEl: e.querySelector(".product-slider-wrapper .swiper-button-prev"),
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        600: {
          slidesPerView: mobileShow,
        },
        768: {
          slidesPerView: tabletShow,
        },
        1024: {
          slidesPerView: largeDesktopShow,
        },
        1280: {
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });
  }
  return sliderProduct;
})();

theme.collectionSlider = (function() {
  function Slider(e) { 
    const initialTheme = localStorage.getItem('theme') || 'light';
    let sliderWrapper = e.querySelector(".slider-swiper"),
        slideLoop = e.dataset.slideLoop,
        slideAutoplay = e.dataset.slideAutoplay,
        autoplayDuration = e.dataset.autoplayDuration,
        slideLoopValue = true,
        autoplay = false,
        slideNavPrev = e.querySelector(".swiper-button-prev"),
        slideNavNext = e.querySelector(".swiper-button-next"),
        sliderPagination = e.querySelector(".swiper-pagination"),
        slideShowSpace = parseInt(e.dataset.slideshow) ? parseInt(e.dataset.slideshow) : 0,
        sliderPerView = parseInt(e.dataset.slidesperview) ? parseInt(e.dataset.slidesperview) : 1,
        smallDesktop = parseInt(e.dataset.samlldesktopview) ? parseInt(e.dataset.samlldesktopview) : 1,
        tabletShow = parseInt(e.dataset.showTablet) ? parseInt(e.dataset.showTablet): 1,
        mobileShow = parseInt(e.dataset.showMobile) ? parseInt(e.dataset.showMobile) : 1;
    
    //console.log(sliderPerView);
    
    if(slideLoop == "false"){
    	 slideLoopValue = false;
    }
    if(slideAutoplay == "true"){
        let sliderDuration = parseInt(autoplayDuration);
    	autoplay = {delay: autoplayDuration, disableOnInteraction: false}
    }
    
    var swiper = new Swiper(sliderWrapper, {
      slidesPerView: mobileShow,
      autoplay: autoplay,
      loop: slideLoopValue,
      clickable: true,
      speed: 500,
      observer: true,
      observeParents: true,
      spaceBetween: slideShowSpace,
      pagination: {
        el: sliderPagination,
        clickable: true,
      },
      navigation: {
        nextEl: slideNavNext,
        prevEl: slideNavPrev,
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
        },
        768: {
          slidesPerView: tabletShow,
        },
        1024: {
          slidesPerView: smallDesktop
        },
        1400: {
          slidesPerView: sliderPerView
        }
      }
    });
    
  }
  return Slider;
})();

function sectionReveal() {
  const sections = document.querySelectorAll('#MainContent .shopify-section');

  if (!('IntersectionObserver' in window)) {
    sections.forEach((section) => section.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      entry.target.classList.toggle('is-visible', entry.isIntersecting);
    });
  });

  document.documentElement.classList.add('section-reveal-enabled');
  sections.forEach((section) => observer.observe(section));

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.closest('.shopify-section');
    if (section) observer.observe(section);
  });
}

document.addEventListener("DOMContentLoaded", function () {

 sectionReveal();
  accordion();
  tab();
  HeaderSticky();
  header_mobile();
  search();
  cartActions();
  categoryMenu();
  footer_faq();
  toggle_view_product();
 
  let sections = new theme.Sections();
  sections.register("slideShow", theme.collectionSlider);
  sections.register("product-slider", theme.productSlider);

  // Función para manejar la selección
  document.addEventListener('click', function (e) {
    if (e.target.closest('.btn-select-mundo')) {
      e.preventDefault();

      // Quitar clase a todas las cards
      document.querySelectorAll('.cont-gabrica > div').forEach(function (el) {
        el.classList.remove('hover-gabrica');
      });

      // Añadir clase solo a la card clickeada
      const card = e.target.closest('.cont-gabrica > div');
      if (card) {
        card.classList.add('hover-gabrica');
      }
    }

    // Manejar acción de atrás
    if (e.target.closest('.atras')) {
      e.preventDefault();
      document.querySelectorAll('.cont-gabrica > div').forEach(function (el) {
        el.classList.remove('hover-gabrica');
      });
    }
  });

  console.log('Gabrica');

  
});
